// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__3QFtU","label":"CategoryService_label__2NNKI","location":"CategoryService_location__16cih"};